module.exports = __webpack_public_path__ + "static/media/background-404.43214024.png";